import { ACTIVE_CHAIN } from "../config/chains";

const base = ACTIVE_CHAIN.explorerUrl.replace(/\/$/, "");
export const explorerTx = (hash: string) => `${base}/tx/${hash}`;
export const explorerAddress = (addr: string) => `${base}/address/${addr}`;
